import '../../style/index.less';
import './index.less';
// style dependencies
import '../../input/style';
import '../../button/style';
import '../../select/style';
